import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import Chart, { ChartEvent } from 'chart.js/auto';
import { changeDeviceView } from '../../../common/app.helpers';
import AppValues from '../../../common/app.values';

export interface PieChartData {
  labels: string[];
  data: number[];
}

@Component({
  selector: 'app-pie-chart',
  templateUrl: './pie-chart.component.html',
  styleUrls: ['./pie-chart.component.scss'],
})
export class PieChartComponent implements OnInit, OnChanges {
  @Input({ required: true }) public pieChartData: PieChartData;

  public colours: string[] = [
    'rgb(27, 226, 188)',
    'rgb(0, 186, 236)',
    'rgb(53, 132, 224)',
    'rgb(7, 216, 216)',
    'rgb(140, 74, 244)',
    'rgb(53, 75, 169)',
    'rgb(79, 194, 156)',
    'rgb(98, 73, 226)',
    'rgb(76, 183, 75)',
    'rgb(0, 14, 128)',
    'rgb(127, 127, 127)',
    'rgb(213, 213, 213)',
  ];
  public chart: Chart;

  private isMobileView: boolean;

  public ngOnInit(): void {
    this.isMobileView = changeDeviceView(AppValues.DEFAULT_WIDTH_FOR_MOBILE);
    this.createChart();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['pieChartData'] && !changes['pieChartData'].firstChange && this.chart) {
      this.updateChart();
    }
  }

  private createChart(): void {
    this.chart = new Chart('MyChart', {
      type: 'pie',
      data: {
        labels: this.pieChartData.labels,
        datasets: [
          {
            data: this.pieChartData.data,
            backgroundColor: this.colours,
          },
        ],
      },
      options: {
        elements: {
          arc: {
            borderWidth: 1,
          },
        },
        plugins: {
          legend: {
            onClick: (_: ChartEvent) => {
              // No action needed on legend click
            },
            display: true,
            position: this.isMobileView ? 'bottom' : 'right',
            labels: {
              boxWidth: 20,
              boxHeight: 20,
              font: {
                size: 16,
                family: 'Muller, Arial, Helvetica, sans-serif',
              },
            },
          },
        },
      },
    });
  }

  private updateChart(): void {
    if (this.chart) {
      this.chart.data.labels = this.pieChartData.labels;
      this.chart.data.datasets[0].data = this.pieChartData.data;
      this.chart.update();
    }
  }
}
